(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/grassroots-shared/assets/javascripts/helpers/dialog.js') >= 0) return;  svs.modules.push('/modules/grassroots-shared/assets/javascripts/helpers/dialog.js');
"use strict";


const {
  dialog
} = svs.ui;

const button = _ref => {
  let {
    title,
    callback
  } = _ref;
  return {
    title,
    callback: callback ? callback : () => {}
  };
};

const injectToButtonCallbacks = (buttons, injection) => {
  buttons.forEach(button => {
    const theCallback = button.callback;
    button.callback = (dialog, form) => {
      injection();
      theCallback(dialog, form);
    };
  });
  return buttons;
};

const text = _ref2 => {
  let {
    text
  } = _ref2;
  return {
    text,
    type: dialog.message.TEXT
  };
};

const checkbox = _ref3 => {
  let {
    checked,
    text,
    value
  } = _ref3;
  return {
    checked: typeof checked === 'boolean' ? checked : false,
    text: text || '',
    type: dialog.message.CHECKBOX,
    value: typeof value === 'boolean' ? value : false
  };
};

const grType = {
  ERROR: 'error',
  INFO: 'info',
  DEFAULT: 'default'
};
const toDialogType = type => {
  switch (type) {
    case grType.ERROR:
      return dialog.type.ERROR;
    case grType.INFO:
    case grType.DEFAULT:
    default:
      return dialog.type.DEFAULT;
  }
};

const grIcon = {
  [grType.ERROR]: 'exclamation-sign',
  [grType.INFO]: 'information',
  [grType.DEFAULT]: 'information'
};

const DEFAULTBUTTON = [button({
  title: 'Ok'
})];
const TENANT = svs.core.detect.tenant('lb') ? 'SPORT' : 'TUR';

const newDialog = _ref4 => {
  var _dialog$api;
  let {
    area,
    autoClose,
    buttons,
    convertToPopup,
    icon,
    message,
    title,
    type
  } = _ref4;
  const theDialog = new dialog.Confirm({
    actions: injectToButtonCallbacks(buttons || DEFAULTBUTTON, () => theDialog.close()),
    area: area || dialog.area.POPUP,
    autoClose: autoClose || 0,
    branding: dialog.branding[TENANT],
    convertToPopup: convertToPopup || false,
    icon: icon || grIcon[type],
    message: message || [],
    title,
    type: toDialogType(type)
  });
  if ((_dialog$api = dialog.api) !== null && _dialog$api !== void 0 && (_dialog$api = _dialog$api.queue) !== null && _dialog$api !== void 0 && _dialog$api.count()) {
    dialog.api.close();
  }
  dialog.api.add(theDialog);

  autoClose && setTimeout(() => theDialog.close(), autoClose);
  return theDialog;
};

const errorPopup = _ref5 => {
  let {
    title,
    message
  } = _ref5;
  return newDialog({
    area: dialog.area.POPUP,
    message: [text({
      text: message
    })],
    title,
    type: grType.ERROR
  });
};

const infoPopup = _ref6 => {
  let {
    title,
    message
  } = _ref6;
  return newDialog({
    area: dialog.area.POPUP,
    message: [text({
      text: message
    })],
    title,
    type: grType.INFO
  });
};

const errorToaster = _ref7 => {
  let {
    autoClose,
    title,
    message
  } = _ref7;
  return newDialog({
    autoClose: autoClose || dialog.autoClose.SHORT,
    area: dialog.area.TOASTER,
    message: [text({
      text: message
    })],
    title,
    type: grType.ERROR
  });
};

const infoToaster = _ref8 => {
  let {
    autoClose,
    title,
    message
  } = _ref8;
  return newDialog({
    autoClose: autoClose || dialog.autoClose.SHORT,
    area: dialog.area.TOASTER,
    message: [text({
      text: message
    })],
    title,
    type: grType.INFO
  });
};
svs.grassroots.helpers.dialog = {
  autoClose: dialog.autoClose,
  errorPopup,
  errorToaster,
  infoPopup,
  infoToaster
};

 })(window);